import { Box, Card, Divider,Chip, Drawer, Typography } from "@mui/material";
import AgGridTable from "../components/table/AgGridTable";
import React, { useEffect, useState } from "react";
import axiosInstance from "../services/axiosInstance";
import { SA_ORGANIZATIONS_LIST } from "../shared/constants/apiEndpoints";
import InviteOrgTableDrawer from "../components/drawer/InviteOrgTableDrawer";

const OrganisationTable = () => {
  const [isTableRowClick, setIsTableRowClick] = React.useState(false);
  const [orgData, setOrgData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [isSelectedRow, setIsSelectedRow] = useState<any>(null);

  useEffect(() => {
    setLoading(true);
    axiosInstance.get(SA_ORGANIZATIONS_LIST)
      .then((res) => {
        // Check if data is nested in response.data.data
        const organizationsData = res.data?.data || res.data;

        
        // Transform API response to match table column structure
        const transformedData = organizationsData?.map((org: any) => ({
          org_name: org.org_name || org.organization_name,
          onboard_by: org.onboarded_by || "System",
          email: org.admin_email || org.organization_email || "",
          status: org.status || "Active",
          subscription: org.subscription || "Unknown",
          licence_updated_on: org.license_updated_on || "24 May 2024",
          scaned_assets: org.scanned_assets || 0,
          scaned_resources: org.scanned_resources || 0,
          security_score: org.security_score || 0,
          users: org.user_count || 0,
          // Add additional fields for debugging
          id: org.org_id || org.id,
          expiry_date: org.expiry_date,
          onboarding_date: org.onboarding_date,
        })) || [];
        
        console.log("=== TRANSFORMED DATA DEBUG ===");
        console.log("Transformed data:", transformedData);
        console.log("Transformed data length:", transformedData?.length);
        console.log("First organization data:", transformedData?.[0]);
        console.log("Is transformed data an array?", Array.isArray(transformedData));
        console.log("==============================");
        
        setOrgData(transformedData || []);
      })
      .catch((err) => {
        console.error("Error fetching organizations:", err);
        setOrgData([]);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleOnRowClick = (row: any) => {
    console.log("Row clicked:", row);
    setIsTableRowClick(true);
    setIsSelectedRow(row.id);
  };
  console.log("isSelectedRow:", isSelectedRow);

  // Debug: Log the data being passed to AgGridTable
  console.log("=== AGGRID DATA DEBUG ===");
  console.log("orgData being passed to AgGridTable:", orgData);
  console.log("orgData length:", orgData?.length);
  console.log("orgData type:", typeof orgData);
  console.log("==========================");
  
  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <Card
        variant="outlined"
        sx={{ height: "calc(100vh - 103px)", borderRadius: 3, width: "100%" }}
      >
        <AgGridTable
          columnDefs={[
            { 
              headerName: "Org Name", 
              field: "org_name",
              cellRenderer: (params: any) => {
                return params.value || "N/A";
              }
            },
            { 
              headerName: "Onboarded by", 
              field: "onboard_by",
              cellRenderer: (params: any) => {
                return params.value || "N/A";
              }
            },
            { 
              headerName: "Email", 
              field: "email",
              cellRenderer: (params: any) => {
                return params.value || "N/A";
              }
            },
            { 
              headerName: "Status", 
              field: "status",
              cellRenderer: (params: any) => {
                return params.value || "N/A";
              }
            },
            { 
              headerName: "Subscription", 
              field: "subscription",
              cellRenderer: (params: any) => {
                return params.value || "N/A";
              }
            },
            { 
              headerName: "License Updated on", 
              field: "licence_updated_on",
              cellRenderer: (params: any) => {
                return params.value || "N/A";
              }
            },
            { 
              headerName: "Scanned Assets", 
              field: "scaned_assets",
              cellRenderer: (params: any) => {
                return params.value || 0;
              }
            },
            { 
              headerName: "Scanned Resources", 
              field: "scaned_resources",
              cellRenderer: (params: any) => {
                return params.value || 0;
              }
            },
            { 
              headerName: "Security Score", 
              field: "security_score",
              cellRenderer: (params: any) => {
                return params.value || 0;
              }
            },
            { 
              headerName: "Users", 
              field: "users",
              cellRenderer: (params: any) => {
                return params.value || 0;
              }
            },
          ]}
          data={orgData}
          showSearch
          isRowSelectable
          height={"calc(88vh - 90px)"}
          onRowClick={handleOnRowClick}
          isLoading={loading}
        />
        <Drawer
          anchor="right"
          open={isTableRowClick}
          onClose={() => setIsTableRowClick(false)}
          sx={{
            "& .MuiDrawer-paper": {
              width: "45%",
              p: 1,
              overflow: "auto",
              scrollbarWidth: "thin",
            },
          }}
        >
          {/* <Typography variant="body2" color="text.secondary">
            {field.label}
          </Typography>
          <Typography variant="subtitle2" fontWeight="bold">
            {field.value}
          </Typography>
          <Divider></Divider> */}
          <InviteOrgTableDrawer setIsTableRowClick={setIsTableRowClick} isSelectedRow={isSelectedRow}/>
        </Drawer>
      </Card>
    </Box>
  );
};

export default OrganisationTable;
